export default function Container({ children, className = "", id="" }) {
    return (
        <div id={id} className={`max-w-[1440px] mx-auto w-full ${className}`}>
            {children}
        </div>
    );
}